<template>
  <div class="popup" v-if="show">
    <van-popup
      v-model="show"
      round
      position="bottom"
      closeable
      @click-close-icon="close"
      :close-on-click-overlay="false"
      :style="{ height: '55%' }"
    >
      <div class="popBox">
        <h5>申请退款</h5>
        <p>退款原因</p>
        <van-form @submit="onSubmit">
          <van-field
            v-model="message"
            rows="2"
            autosize
            type="textarea"
            maxlength="30"
            placeholder="请输入退款原因"
            show-word-limit
            :rules="[{ required: true, message: '请输入退款原因' }]"
          />
          <p class="p">
            申请退款后，请等待工作人员审核，成功后为您退款，请耐心等待…
          </p>
          <div style="margin: 16px">
            <van-button
              round
              block
              type="info"
              native-type="submit"
              color="linear-gradient(to top, #24BFFB, #17E1EB)"
              class="btn"
              >提交退款申请</van-button
            >
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "contact-us",
  props: ["popShow"],
  data() {
    return {
      show: false,
      message: "",
    };
  },
  watch: {
    popShow(n, o) {
      this.message = "";
      this.show = n;
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$emit("submitRefundMsg", this.message);
    },
  },
};
</script>
<style lang="scss" scoped>
.popBox {
  padding: 20px 15px;
  color: #2e4344;
  h5 {
    font-size: 16px;
    text-align: center;
    font-weight: 500;
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 10px;
    font-size: 14px;
    padding: 0 5px;
  }
  .van-cell {
    background: #f3f6f7;
    border-radius: 8px;
    margin-bottom: 10px;
  }
  .p {
    line-height: 25px;
    padding: 0 5px 50px 5px;
  }
  .btn {
    font-size: 16px;
    letter-spacing: 1px;
    position: fixed;
    bottom: 10px;
    left: 5%;
    width: 90%;
  }
}
</style>
